var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h24v24H0V0z",
    transform: "translate(-450 -3811) translate(0 3692) translate(450 119)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M2 3h2c0 9.389 7.611 17 17 17v2C10.507 22 2 13.493 2 3zm4.857 7.488c-.304-.573-.575-1.167-.808-1.778C5.37 6.936 5 5.01 5 3h2c0 1.77.329 3.465.929 5.024.202.525.434 1.035.695 1.528l-1.767.936zm6.536 6.591l.95-1.76C16.324 16.391 18.592 17 21 17v2c-2.754 0-5.345-.696-7.607-1.92z",
    transform: "translate(-450 -3811) translate(0 3692) translate(450 119)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPhone);
export default __webpack_public_path__ + "static/media/icons-phone.d5c1d3ea3020bfc4a38e74c40c5273df.svg";
export { ForwardRef as ReactComponent };